/* jshint esnext: true */
import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Map';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.customMarker = null;
        this.points = options.points || [];
        this.API_KEY = options.api;
    }

    init() {

        // Async loading
        if (typeof google === 'undefined') {
            // If google is undefined,
            window._tmp_google_onload = () => {
                this.init();
            };

            $.getScript(
                'https://maps.googleapis.com/maps/api/js?sensor=true&v=3' +
                '&language=en&callback=_tmp_google_onload&key=' + this.API_KEY,
                function() {}
            );

            return false;
        }


        let directionsService = new google.maps.DirectionsService();
        let directionsDisplay = new google.maps.DirectionsRenderer({
            markerOptions: {
                opacity: 0
            },
            polylineOptions: {
                strokeColor: "#101424",
                strokeOpacity: 0.0
            }
        });

        let center = this.points[0].split(',');

        let map = new google.maps.Map(this.el, {
          zoom: 8,
          center:  {lat: 43.7300919, lng: -81.6811776},
          disableDefaultUI: true,
          scrollwheel: false,
          styles: [{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20},{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2},{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text","stylers":[{"weight":"1"},{"visibility":"simplified"},{"color":"#49608f"}]},{"featureType":"administrative","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"lightness":20},{"color":"#222946"}]},{"featureType":"landscape","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"off"},{"color":"#222946"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"lightness":21},{"color":"#222946"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"},{"color":"#ff0000"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":17},{"visibility":"on"},{"color":"#273664"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":29},{"weight":0.2},{"visibility":"off"},{"color":"#293969"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"lightness":18},{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#4f6093"},{"lightness":16},{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#5d5f66"},{"lightness":19},{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.text","stylers":[{"visibility":"off"},{"color":"#222946"}]},{"featureType":"transit.line","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"lightness":17},{"visibility":"on"},{"color":"#29385f"}]},{"featureType":"water","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]}]
        });

        directionsDisplay.setMap(map);

        if (this.points.length >= 1) {
            this.initCustomMarker();

            let bound = new google.maps.LatLngBounds();
            let points = this.points;
            let waypoints = [];
            for (let point in points) {
                if (!points[point].length) {
                    return;
                }
                let p = points[point].split(',');
                points[point] = new google.maps.LatLng(
                    parseFloat(p[0]),
                    parseFloat(p[1])
                );

                bound.extend(points[point]);

                if (point > 0 && point < points.length -1) {
                    waypoints.push({
                        location: points[point],
                        stopover: true
                    });
                }

                let index = parseInt(point) + 1;
                let markup = '<div class="c-map_custom_marker js-animate" data-target=".c-section-route"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.23 45" height="45" width="35.23"><title>marker</title><path d="M33.23,9.69A17.58,17.58,0,0,0,9.63,1.87a17.82,17.82,0,0,0-7.82,23.6c2,3.93,10.28,14.17,13.93,18.67a2.28,2.28,0,0,0,3.55,0c3.65-4.5,11.85-14.74,14-18.67A16.77,16.77,0,0,0,33.23,9.69Z" fill="#E62D39"/><path d="M17.61,26.8a9.15,9.15,0,1,1,9.15-9.15A9.15,9.15,0,0,1,17.61,26.8Z" fill="#FFF"/></svg><span>'+ index +'</span></div></div>';
                let marker = $(markup).appendTo(this.$el.get(0));

                new this.customMarker (
                    points[point],
                    map,
                    {
                        marker: $(marker).get(0)
                    }
                );
                $('.js-scroll').triggerHandler('update.LocomotiveScroll', $(marker).get(0));
                // var marker = new google.maps.Marker({
                //     position: new google.maps.LatLng(
                //         parseFloat(p[0]),
                //         parseFloat(p[1])
                //     ),
                //     map: map
                // });
            }

            let origin = points[0];
            let destination = points[points.length -1];

            let request = {
                origin: origin,
                destination: destination,
                waypoints: waypoints,
                optimizeWaypoints: false,
                travelMode: 'DRIVING'
            };

            directionsService.route(request, function(result, status) {
                if (status == 'OK') {
                    directionsDisplay.setDirections(result);
                }
            });

            map.fitBounds(bound);

        }

    }

    // ==========================================================================
    // CustomMarker
    // ==========================================================================

    initCustomMarker() {

        if (typeof this.customMarker === "function") {
            return this.customMarker;
        }

        this.customMarker = function (latlng, map, args) {
            this.latlng = latlng;
            this.args   = args;
            this.setMap(map);

        };

        this.customMarker.prototype = new google.maps.OverlayView();

        this.customMarker.prototype.draw = function () {

            var self = this;

            var div = this.div;

            if (!div) {

                if (this.args['marker']) {
                    div = this.args['marker'];
                } else {
                    div = this.div = document.createElement('div');
                    div.className      = 'marker';
                    div.style.position = 'absolute';
                    div.style.cursor   = 'pointer';
                }

                if (typeof(self.args.marker_id) !== 'undefined') {
                    div.dataset.marker_id = self.args.marker_id;
                }

                google.maps.event.addDomListener(div, "click", function (event) {
                    google.maps.event.trigger(self, "click");
                });

                var panes = this.getPanes();
                panes.overlayImage.appendChild(div);
            }

            var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

            if (point) {
                div.style.left = point.x + 'px';
                div.style.top  = point.y + 'px';
            }
        };

        this.customMarker.prototype.remove = function () {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        };

        this.customMarker.prototype.getPosition = function () {
            return this.latlng;
        };

        return this.customMarker;

    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
